'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function (input) {
  return input.replace(/ *\(tm\)/gim, '™');
};

module.exports = exports['default'];

